import { Table } from "flowbite-react";
import { HistoryDto } from "../../../types/dto/history-dto";
import { Footnote12Description } from "../../typography/Footnote12Description";
import { CustomCell } from "../CustomCell";
import { Row } from "./Row";

interface Props {
  history: HistoryDto[];
}

const headers = [
  { title: "수정 항목", className: "w-[189.33px] p-0" },
  { title: "수정 전", className: "w-[189.33px] p-0" },
  { title: "수정 후", className: "w-[189.33px] p-0" },
  { title: "수정자", className: "w-[88px] p-0" },
  { title: "수정 일자", className: "w-[160px] p-0" },
];

export const HistoryTable: React.FC<Props> = ({ history }) => {
  return (
    <div className="overflow-x-auto rounded-[8px] border h-[348px]">
      <Table className=" overflow-scroll">
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell className={header.className} key={header.title}>
              <CustomCell>
                <Footnote12Description>{header.title}</Footnote12Description>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {history.map((data, index) => (
            <Row key={index} data={data} />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};
